module.exports = __webpack_public_path__ + "img/fancy-check.8845abb4.svg";